export enum UIErrorCode {
  // GENERIC
  SERVER_ERROR = 'SERVER_ERROR',
  //AUTH
  UNAUTHORIZED = 'UNAUTHORIZED',
  AUTH_INVALID_INPUT = 'AUTH_INVALID_INPUT',
  // CALL SEQUENCE
  CALL_SEQUENCE_NOT_FOUND = 'CALL_SEQUENCE_NOT_FOUND',
  // PROVIDER CONTACT
  CREATE_UPDATE_PROVIDER_CONTACT = 'CREATE_UPDATE_PROVIDER_CONTACT',
  CREATE_UPDATE_PROVIDER_CONTACT_INVALID_INPUT = 'CREATE_UPDATE_PROVIDER_CONTACT_INVALID_INPUT',

  DELETE_PROVIDER_CONTACT = 'DELETE_PROVIDER_CONTACT',
  DELETE_PROVIDER_CONTACT_INVALID_INPUT = 'DELETE_PROVIDER_CONTACT_INVALID_INPUT',

  LIST_PROVIDERS = 'LIST_PROVIDERS',
  LIST_PROVIDERS_INVALID_INPUT = 'LIST_PROVIDERS_INVALID_INPUT',
  // PATIENT CONTACT
  CREATE_UPDATE_PATIENT_CONTACT = 'CREATE_UPDATE_PATIENT_CONTACT',
  CREATE_UPDATE_PATIENT_CONTACT_INVALID = 'CREATE_UPDATE_PATIENT_CONTACT_INVALID',

  DELETE_PATIENT_CONTACT = 'DELETE_PATIENT_CONTACT',
  DELETE_PATIENT_CONTACT_INVALID_INPUT = 'DELETE_PATIENT_CONTACT_INVALID_INPUT',

  LIST_PATIENT_CONTACT = 'LIST_PATIENT_CONTACT',
  LIST_PATIENT_CONTACT_INVALID_INPUT = 'LIST_PATIENT_CONTACT_INVALID_INPUT',

  // CALLS/MESSAGES
  LIST_CALLS_MESSAGES = 'LIST_CALLS_MESSAGES',

  // NOTIFY CONTACT
  NOTIFY_CONTACT = 'NOTIFY_CONTACT',
  NOTIFY_CONTACT_NO_REQUEST = 'NOTIFY_CONTACT_NO_REQUEST',
  NOTIFY_CONTACT_NO_PATIENT = 'NOTIFY_CONTACT_NO_PATIENT',
  NOTIFY_CONTACT_NO_PROVIDER = 'NOTIFY_CONTACT_NO_PROVIDER',
  NOTIFY_CONTACT_US_PHONE = 'NOTIFY_CONTACT_US_PHONE',

  // TWILIO
  TWILIO = 'TWILIO',

  // UPDATE ORG RELATED RESOURCES
  UPDATE_ORG_RESOURCES_FROM_DYNAMO = 'UPDATE_ORG_RESOURCES_FROM_DYNAMO',
  UPDATE_ORG_RESOURCES_FROM_DYNAMO_INVALID_KEY = 'UPDATE_ORG_RESOURCES_FROM_DYNAMO_INVALID_KEY',

  // LOGGING
  LOG_EVENT = 'LOG_EVENT',
  LOG_EVENT_INVALID = 'LOG_EVENT_INVALID',
  LOG_ERROR = 'LOG_ERROR',
  LOG_ERROR_INVALID = 'LOG_ERROR_INVALID',

  ORG_USER_MANAGEMENT = 'ORG_USER_MANAGEMENT',
}
